<template>
    <div class="modal-mask" @click.self="$emit('fecharModal')">
        <div class="jm margem" style="min-width: 30vw; max-width: 70vw; max-height: 90vh; overflow: auto;" @click.stop>
            <template v-if="tarefa">
                <div class="alinha-centro m-b">
                    <h2>{{ tarefa.codigo ?? '-' }}</h2>
                </div>
                <fieldset class="grid-2">

                    <div class="grid-2">

                        <div>
                            <label>Responsável</label>
                            <select v-model="tarefa.responsavel_id" :disabled="!isCoordenador && !isAuditor"
                                @change="atualizarTarefa({ responsavel_id: tarefa.responsavel_id })">
                                <option :hidden="isAuditor ? false : !subordinados.includes(item.id)"
                                    v-for="item in usuarios" :key="item.id" :value="item.id">
                                    {{ item.nomeCompleto }}
                                </option>
                            </select>
                        </div>
                        <div v-if="tarefa.tipo !== 1001"><label>HP</label>
                            <input type="number" v-model="tarefa.HP" :disabled="!isCoordenador && !isAuditor"
                                @change="atualizarTarefa({ HP: `${tarefa.HP}` })">
                        </div>

                    </div>
                    <div v-if="todasTarefas">
                        <label>Tarefa anterior</label>
                        <select v-model="tarefa.parente_id"
                            @change="atualizarTarefa({ parente_id: tarefa.parente_id })">
                            <option :value="null">Nenhuma</option>
                            <option v-for="item in todasTarefas" :key="item.id" :value="item.id"
                                :hidden="item.id === tarefa.id">
                                {{ item.codigo ?? '-' }}: {{ item.descricao }}
                            </option>
                        </select>
                    </div>

                    <div class="col-2">
                        <label>Descrição</label>
                        <textarea v-model="tarefa.descricao" :disabled="!isCoordenador && !isAuditor"
                            @focusout="atualizarTarefa({ descricao: tarefa.descricao })"></textarea>
                    </div>

                    <div>
                        <label>Início Previsto</label>
                        <input v-model="tarefa.dtInicio" type="date" :disabled="!isCoordenador && !isAuditor"
                            @change="atualizarTarefa({ dtInicio: tarefa.dtInicio || null })">
                    </div>
                    <div>
                        <label>Fim Previsto</label>
                        <input v-model="tarefa.dtFim" type="date" :disabled="!isCoordenador && !isAuditor"
                            @change="atualizarTarefa({ dtFim: tarefa.dtFim || null })">
                    </div>
                    <div>
                        <label>Inicio Real</label>
                        <input v-model="tarefa.dtInicioReal" type="date" :disabled="!isCoordenador && !isAuditor"
                            @change="atualizarTarefa({ dtInicioReal: (tarefa.dtInicioReal + ' ' + `${dataHora}`) })">
                    </div>
                    <div>
                        <label>Fim Real</label>
                        <input v-model="tarefa.dtFimReal" type="date" :disabled="!isCoordenador && !isAuditor"
                            @change="atualizarTarefa({ dtFimReal: (tarefa.dtFimReal + ' ' + `${dataHora}`) })">
                    </div>

                    <div v-if="tarefa.tipo !== 1001" class="col-2">
                        <label>Entidade Associada</label>
                        <div class="alinha-v" style="gap: .5rem">
                            <select style="width: fit-content" v-model="filtroTipo">
                                <option :value="null" hidden>Tipo</option>
                                <option :value="5">PAP</option>
                                <option :value="4">OS</option>
                                <option :value="1">TNC</option>
                                <option :value="3">RAP</option>
                            </select>
                            <select :disabled="!filtroTipo" v-model="tarefa.protocoloAssociado_id"
                                @change="atualizarTarefa({ protocoloAssociado_id: tarefa.protocoloAssociado_id })">
                                <option hidden :value="null"></option>
                                <option v-for="p in protocolos" :key="p.id" :value="p.id"
                                    :hidden="p.tipo_id !== filtroTipo">{{ p.codigo }} - {{ p.nome }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-2">
                        <label>Observações</label>
                        <textarea v-model="tarefa.obs" rows="6"
                            @focusout="atualizarTarefa({ obs: tarefa.obs })"></textarea>
                    </div>
                    <div v-if="tarefa.tipo !== 1001" class="col-2">
                        <label>Reuniões em que foi discutida</label>
                        <p v-if="carregandoReunioes" class="fonte-fraca fonte-menor">Carregando reuniões…</p>
                        <p v-else-if="reunioes.length === 0" class="fonte-fraca fonte-menor">
                            Esta tarefa ainda não foi discutida em nenhuma reunião.
                        </p>
                        <ul v-else class="lista-reunioes-tarefa">
                            <li v-for="reuniao in reunioes" :key="reuniao.id">
                                <span class="chip bg-cinza">{{ formatarDataHoraBr(reuniao.start) }}</span>
                                <a v-if="reuniao.html_link" :href="reuniao.html_link" target="_blank" rel="noopener">
                                    {{ reuniao.summary || 'Reunião sem título' }}
                                </a>
                                <span v-else>{{ reuniao.summary || 'Reunião sem título' }}</span>
                            </li>
                        </ul>
                    </div>

                    <div v-if="tarefa.tipo !== 1001" class="col-2" style="margin-bottom: 0">
                        <span>
                            Anexos:
                        </span>
                        <input style="display: none" ref="fileInput" type="file" @change="adicionarAnexo">

                        <ul style="list-style: none; margin-bottom: 0;" class="grid-3">
                            <li v-for="item in tarefa.anexos" :key="item">
                                <div class="anexo">
                                    <a :href="caminhoFoto + item.path" target="_blank">
                                        {{ item.nome }}
                                    </a>
                                    <i v-if="isCoordenador || isAuditor" @click="excluirAnexo(item.id)" style="color: red"
                                        class="bi bi-trash-fill botaoAdicionarSprint"></i>
                                </div>
                            </li>
                            <div @click="openFileInput" style="cursor: pointer" class="anexo botaoAdicionarSprint">
                                Adicionar <i title="Adicionar anexo" style="justify-self: right;"
                                    class="bi-plus-circle"></i>
                            </div>
                            <input type="file" style="display: none" ref="fileInput" @change="adicionarAnexo">
                        </ul>
                    </div>
                </fieldset>
            </template>
        </div>
    </div>
</template>

<script>
import serviceProjetos from '@/services/serviceProjetos';
import serviceProtocolo from '@/services/serviceProtocolo';
import { atualizarTarefaReuniaoGoogle } from '@/services/serviceGestaoTarefas';
import { formatarDataHoraBr } from '@/utils/date';
import { ref } from 'vue';

export default {
    name: 'modalEditarTarefa',
    props: {
        propTarefa: {
            required: true
        },
        isAuditor: {
            required: true
        },
        isCoordenador: {
            required: true
        },
        usuarios: {
            required: true
        },
        subordinados: {
            required: true
        },
        todasTarefas: {
            required: false
        }
    },
    setup() {

        const fileInput = ref(null);

        const openFileInput = () => {
            fileInput.value.click();
        };

        return { fileInput, openFileInput };

    },
    data() {
        return {
            tarefa: this.propTarefa,
            caminhoFoto: process.env.VUE_APP_ROOT_STORAGE,
            filtroTipo: null,
            protocolos: [],
            reunioes: [],
            carregandoReunioes: false,
        }
    },
    computed: {
        dataHora() {
            return `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
        }
    },
    mounted() {
        this.getProtocolos()
        this.getReunioes()
    },
    methods: {
        formatarDataHoraBr,
        async getReunioes() {
            if (this.tarefa.tipo === 1001 || !this.tarefa.id) return
            this.carregandoReunioes = true
            try {
                this.reunioes = await serviceProjetos.listarReunioesDaTarefa(this.tarefa.id)
            } catch (_) {
                this.reunioes = []
            } finally {
                this.carregandoReunioes = false
            }
        },
        async getProtocolos() {
            var response = await serviceProtocolo.listarTodosProtocolos();
            if (this.tarefa.protocoloAssociado_id) {
                var protocolo = response.find(p => p.id === this.tarefa.protocoloAssociado_id);
                this.filtroTipo = protocolo.tipo_id
            }
            this.protocolos = response.reverse();
        },
        async atualizarTarefa(payload) {
            if (this.tarefa.tipo === 1001) {
                const reuniaoId = this.tarefa.origem_id;
                if (!reuniaoId) return;
                const api = {};
                if ('responsavel_id' in payload) api.responsavel_id = payload.responsavel_id;
                if ('descricao' in payload) api.descricao = payload.descricao;
                if ('obs' in payload) api.obs = payload.obs;
                const setDate = (fromKey, toKey) => {
                    if (fromKey in payload) {
                        const v = payload[fromKey];
                        api[toKey] = v ? String(v).trim().split(/\s/)[0] : null;
                    }
                };
                setDate('dtInicio', 'dt_inicio');
                setDate('dtFim', 'dt_fim');
                setDate('dtInicioReal', 'dt_inicio_real');
                setDate('dtFimReal', 'dt_fim_real');
                if (Object.keys(api).length === 0) return;
                try {
                    await atualizarTarefaReuniaoGoogle(reuniaoId, this.tarefa.id, api);
                } catch (e) {
                    console.error(e);
                }
                return;
            }
            payload.usuario_id = this.idUsuario;
            serviceProjetos.atualizarTarefa(this.tarefa.id, payload);

            if ('status' in payload) {
                this.$emit('definirDatasReais', this.tarefa.id, payload.status)
            }
        },
        async adicionarAnexo() {
            if (this.tarefa.tipo === 1001) return;
            const fileInput = this.$refs.fileInput;

            if (fileInput && fileInput.files.length > 0) {
                const formData = new FormData();
                formData.append('sprintTarefa_id', this.tarefa.id);

                for (let i = 0; i < fileInput.files.length; i++) {
                    formData.append('anexos[]', fileInput.files[i]);
                }

                var response = await serviceProjetos.adicionarAnexoTarefa(formData);
                if (process.env.NODE_ENV === 'development') console.log(response);
                this.tarefa.anexos.push({
                    path: response.anexos_salvos[0].path,
                    nome: response.anexos_salvos[0].nome,
                    id: response.anexos_salvos[0].id
                });
            }
        },

        async excluirAnexo(id) {
            await serviceProjetos.excluirAnexoTarefa(id);
            this.tarefa.anexos = this.tarefa.anexos.filter(anexo => anexo.id !== id)
        },
    },
}
</script>

<style scoped>
.lista-reunioes-tarefa {
    list-style: none;
    margin: 0.4rem 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.lista-reunioes-tarefa li {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.fonte-menor {
    font-size: 0.85rem;
    margin: 0.4rem 0 0;
}

/* .anexo {
    i {
        visibility: hidden;
    }
}

.anexo:hover {
    i {
        visibility: visible;
    }
} */
</style>